// extracted by mini-css-extract-plugin
export var configurationSection = "_z1-0";